import React from 'react';
import { Button, Form, Row, Col, Modal } from 'react-bootstrap';
import { useMutation, useQueryClient } from 'react-query';
import { Formik } from 'formik';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { DANHMUCHOSOTIENSI_API } from '../../../../utils/apiUrl';
import { Post } from '../../../../utils/httpProvider';

const schema = yup.object().shape({
    tenLoaiHoSo: yup.string().required('Vui lòng nhập tên thư mục'),
    ngayTao: yup.date().nullable(),
    moTa: yup.string()
});

const DanhMucHoSoTienSiAdd = ({ setViewMode, refreshList }) => {
    const queryClient = useQueryClient();

    const addFunc = useMutation((value) => Post(DANHMUCHOSOTIENSI_API.CREATE, null, value, false));

    const handleCreate = (values, { setSubmitting }) => {
        const requestData = {
            TenLoaiHoSo: values.tenLoaiHoSo || null,
            NgayTao: values.ngayTao || null,
            MoTa: values.moTa || null
        };

        addFunc.mutate(requestData, {
            onSuccess: (res) => {
                setSubmitting(false);
                if (res && (res.status === 200 || res.status === 201 || res.status === 204 || res.id)) {
                    toast.success('Thêm mới thành công');
                    queryClient.invalidateQueries(['danhMucHoSoTienSiData']);
                    if (refreshList) {
                        refreshList();
                    }
                    setViewMode('list');
                } else {
                    toast.error(res?.message || 'Có lỗi xảy ra');
                }
            },
            onError: (err) => {
                setSubmitting(false);
                toast.error(err?.message || 'Có lỗi xảy ra trong quá trình xử lý');
            }
        });
    };

    return (
        <Modal show={true} onHide={() => setViewMode('list')} size="lg" backdrop="static">
            <Modal.Header closeButton className="bg-primary text-white">
                <Modal.Title>Thêm mới danh mục lưu trữ hồ sơ</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={handleCreate}
                    initialValues={{
                        tenLoaiHoSo: '',
                        ngayTao: new Date(new Date().getTime() - (new Date().getTimezoneOffset() * 60000)).toISOString().split('T')[0],
                        moTa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, handleBlur, values, errors, touched, isSubmitting }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Tên thư mục <span className="text-danger">*</span></Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="tenLoaiHoSo"
                                            value={values.tenLoaiHoSo}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Nhập tên thư mục..."
                                        />
                                        {touched.tenLoaiHoSo && !!errors.tenLoaiHoSo && <div className="text-danger mt-1" style={{ fontSize: '13px' }}>{errors.tenLoaiHoSo}</div>}
                                    </Form.Group>
                                </Col>
                                <Col md={6}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Ngày tạo</Form.Label>
                                        <Form.Control
                                            type="date"
                                            name="ngayTao"
                                            value={values.ngayTao}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={12}>
                                    <Form.Group>
                                        <Form.Label className="font-weight-bold">Mô tả</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={3}
                                            name="moTa"
                                            value={values.moTa}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            placeholder="Nhập mô tả..."
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                            <div className="text-right mt-3">
                                <Button
                                    variant="secondary"
                                    onClick={() => setViewMode('list')}
                                    className="mr-2"
                                    disabled={isSubmitting}
                                >
                                    Hủy
                                </Button>
                                <Button
                                    variant="primary"
                                    type="submit"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? <><i className="fas fa-spinner fa-spin mr-1"></i> Đang lưu...</> : 'Lưu lại'}
                                </Button>
                            </div>
                        </Form>
                    )}
                </Formik>
            </Modal.Body>
        </Modal>
    );
};

export default DanhMucHoSoTienSiAdd;
